/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  GET_PASSWORD_POLICIES_START,
  GET_PASSWORD_POLICIES_SUCCESS,
  GET_PASSWORD_POLICIES_FAILURE,
  GET_PASSWORD_POLICY_DETAILS_START,
  GET_PASSWORD_POLICY_DETAILS_SUCCESS,
  GET_PASSWORD_POLICY_DETAILS_FAILURE,
  GET_PASSWORD_POLICIES_RULE_START,
  GET_PASSWORD_POLICIES_RULE_SUCCESS,
  GET_PASSWORD_POLICIES_RULE_FAILURE,
  FETCH_UPDATE_DATA_FORM_VALUES
} from './types';
import { PasswordPolicyModel, PasswordPolicyDetails, IPasswordPolicyRule } from '../../models/PasswordPolicy/PasswordPolicy';

export const getPasswordPoliciesStart = () => {
  return {
    type: GET_PASSWORD_POLICIES_START
  };
};

export const getPasswordPoliciesSuccess = (passwordPolicies: PasswordPolicyModel[]) => {
  return {
    type: GET_PASSWORD_POLICIES_SUCCESS,
    passwordPolicies
  };
};

export const getPasswordPoliciesFailure = (error: string) => {
  return {
    type: GET_PASSWORD_POLICIES_FAILURE,
    error
  };
};

export const getPasswordPolicyDetailsStart = (passwordPolicyId: string) => {
  return {
    type: GET_PASSWORD_POLICY_DETAILS_START,
    passwordPolicyId
  };
};

export const getPasswordPolicyDetailsSuccess = (passwordPolicyId: string, policyDetails: PasswordPolicyDetails) => {
  return {
    type: GET_PASSWORD_POLICY_DETAILS_SUCCESS,
    passwordPolicyId,
    policyDetails
  };
};

export const getPasswordPolicyDetailsFailure = (passwordPolicyId: string, error: string) => {
  return {
    type: GET_PASSWORD_POLICY_DETAILS_FAILURE,
    passwordPolicyId,
    error
  };
};

export const getPasswordPoliciesRuleStart = () => {
  return {
    type: GET_PASSWORD_POLICIES_RULE_START
  };
};

export const getPasswordPoliciesRuleSuccess = (data: IPasswordPolicyRule) => {
  return {
    type: GET_PASSWORD_POLICIES_RULE_SUCCESS,
    data
  };
};

export const getPasswordPoliciesRuleFailure = (error: string) => {
  return {
    type: GET_PASSWORD_POLICIES_RULE_FAILURE,
    error
  };
};

export const fetchUpdateFormValue = (data: any) => {
  return {
    type: FETCH_UPDATE_DATA_FORM_VALUES,
    data
  };
};